<template>
    <div class="layout-header">
        <div class="layout-header--content">
            <h1>{{ $t(title) }}</h1>
            <p>{{ $t(text) }}</p>
        </div>
        <div class="layout-header--button">
            <el-button v-for="(button, index) in redirectButtons" :key="index"
                class="button add-button" 
                type="success" 
                icon="el-icon-plus"
                @click="add(button.path, button.param)"
                > {{ $t(button.text) }}
            </el-button>
        </div>
    </div>
</template>

<script>
    export default {
        props: 
            {
            title: {
                type: String,
                required: false
            },
            path: {
                type: String,
                required: false
            },
            param: {
                required: false
            },
            value: {
                type: String,
                required: false
            },
            text: {
                type: String,
                required: false
            },
            show: {
                type: Boolean
            },
            redirectButtons: {
                type: Array
            }
        },
        created(){
            console.log(this.redirectButtons)
        },
        computed: {
            isShowed() {
                return !!this.show 
            }  
        },
        methods: {
            add (path, param) {
                this.$router.push({
                    name: path,
                    params: param
                })
            }
        }
    }
</script>

<style scoped>

    h1, p {
        color: grey;
        font-weight: 500;
        margin-left: 5px;
    }

    h1 {
        margin-bottom: 0px;
    }

    .add-button {
        background: #54ad75;
    }

    .add-button:hover, :focus {
        background: #50a56f;
    }

    .button {
        border: 0;
        margin-left: 5px;
        margin-bottom: 10px;
        min-width: 200px;
    }
    
    .layout-header {
        width: 100%;
        display: inline-flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-self: center;
        align-items: space-around
    }

    .layout-header--content {
        min-width: 300px;
    }

    .layout-header--button {
        display: inline-flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-self: center;
        align-items: space-between;
    }

</style>



// WEBPACK FOOTER //
// src/components/LayoutPart/LayoutHeaders.vue